module.exports = __webpack_public_path__ + "src/assets/menu-images/Mastercard Symbol - PNG/mc_symbol_web-artwork_qrg_210112.pdf";